import {
  inject,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';
import { RankedTester } from '@jsonforms/core';

import { STORE } from '@plugins/middleware-sdk';
import { SmartformsTenant } from '@plugins/smartforms-lib/models';

import {
  DhlDocService,
  DocService,
  MaterialDocService,
} from '../services/doc.service';

import dhlJsonFormsRenderers from './dhl';
import materialJsonFormsRenderers from './material';
export type Renderer = {
  tester: RankedTester;
  renderer: unknown;
};
export const JSON_FORMS_RENDERERS = new InjectionToken<Renderer[]>(
  'jsonforms.renderers',
);
export const JSON_FORMS_TENANT = new InjectionToken<string>('jsonforms.tenant');
async function jsonFormsRenderers(tenant: string): Promise<Renderer[]> {
  switch (tenant) {
    case SmartformsTenant.DHL:
      return dhlJsonFormsRenderers();
    default:
      return materialJsonFormsRenderers();
  }
}
function jsonFormsDocService(tenant: string): DocService {
  switch (tenant) {
    case SmartformsTenant.DHL:
      return new DhlDocService();
    default:
      return new MaterialDocService();
  }
}

let renderers: Renderer[];
let tenant: string | undefined;
let docService: DocService;

/**
 * Route resolver that loads tenant-specific renderers from the SDK store.
 * Must run on routes guarded by AuthGuard so the JWT is already available.
 */
export const jsonFormsRendererResolver = async () => {
  const store = inject(STORE);
  const _tenant = await store.get<string | undefined>('tenant', 'tenant');
  tenant = _tenant;
  renderers = await jsonFormsRenderers(_tenant);
  docService = jsonFormsDocService(_tenant);
  return true;
};

export function provideJsonFormsRenderers() {
  return [
    makeEnvironmentProviders([
      {
        provide: JSON_FORMS_RENDERERS,
        useFactory: () => renderers,
      },
      {
        provide: JSON_FORMS_TENANT,
        useFactory: () => tenant,
      },
      {
        provide: DocService,
        useFactory: () => docService,
      },
    ]),
  ];
}
